import React, { useEffect, useState } from 'react'
import { Button, Modal, Nav } from 'react-bootstrap'
import filtericon from "../../assets/images/Filter.png";
import DataTable from 'react-data-table-component';
import { RiArrowDownSLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { BsThreeDots } from "react-icons/bs";
import { deleteOrderItem, getCompletedOrdersListing, getOrdersListing, getRejectedOrdersListing } from '../../api/context/orders';
import Loader from '../../components/loader/loader';
import { Box, Paper, Tooltip } from "@mui/material";
import moment from 'moment';
import ordernew from '../../assets/images/order-new.png';
import deleteIcon from "../../assets/images/delete.png";
import editIcon from "../../assets/images/edit.png";
import viewIcon from "../../assets/svg/view.svg";
import CustomisedModal from '../../components/Modal/CustomisedModal';
import { FaRegSquarePlus } from 'react-icons/fa6';
import CreateBanner from './CreateBanner';
import { getInventoryListingPaginate } from '../../api/context/products';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { createBanner, deleteBannerItem, editBanner, getBannerListing } from '../../api/context/banner';
import toast from 'react-hot-toast'
import imageToBase64 from 'image-to-base64/browser';
import { checkUserPermissions } from '../../helpers/permission';


const queueDatatableCustomStyles = {
    header: {
        style: {
            fontWeight: '600',
            fontSize: '22px',
            color: '#000',
        },
    },
   headCells: {
    style: {
      display: "flex",
      justifyContent: "center",
      fontWeight: '600',
      fontSize: '14px',
      padding: '16px 8px',
      backgroundColor: '#f9f9f9ff',
    },
  },
    cells: {
        style: {
            display: "flex",
            // justifyContent: "center",
            fontSize: '12px',
            fontWeight: '500',
            padding: '12px',
        },
    },

};

const customStyless = {
    control: (provided) => ({
        ...provided,
        border: " 1px solid #a7a7a7",
        padding: '6px',
    }),
};



const Banner = () => {

    const navigate = useNavigate()

    const [show, setShow] = useState(false);
    const [banner, setBanner] = useState([]);
    const [products, setProducts] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [update, setUpdate] = useState(false);
    const [initial, setInitial] = useState(false);
    const [search, setSearch] = useState("");
    const [modal, setModal] = useState(false);
    const [deletingId, setDeletingId] = useState("");
    const [selectedBanner, setSelectedBanner] = useState(null);
    const [showimg, setShowImg] = useState(false);
    const [webimg, setWebImg] = useState([]);
    const [showmobimg, setShowMobImg] = useState(false);
    const [mobimg, setMobImg] = useState([]);

    const handleShowWebImage = (promoimage) => {
        setShowImg(true);
        setWebImg(promoimage)
    }

    const handleShowMobImage = (promoimage) => {
        setShowMobImg(true);
        setMobImg(promoimage)
    }

    const handleCloseImage = () => {
        setShowImg(false);
    }

    const handleCloseMobImage = () => {
        setShowMobImg(false);
    }

    const columns = [
        {
            name: "S. No.",
            selector: (row, index) => ((page * limit) - limit) + (index + 1),
            width: '90px',
            center: true
        },
        {
            id: 'title',
            name: 'Title',
            selector: (row) => row?.title,
            cell: (row) => (
                <Tooltip title={row?.title} disableInteractive placement='top'>
                    <div className='text-truncate text-center'>{row?.title}</div>
                </Tooltip>
            ),

            minWidth: '150px',
            center: true
        },
        {
            id: "mobileImage",
            name: "Banner Image",
            selector: (row) => row?.mobileImage,
            cell: (row) => (
                <div className="promocode_img_wrapper d-flex justify-content-center" onClick={() => handleShowMobImage(row?.mobileImage)}>
                    <img src={row?.mobileImage} alt={row?.title} className="img-fluid" />
                </div>
            ),
            grow: 0.5,
            minWidth: '150px',
            center: true
        },
        {
            id: 'createdAt',
            name: 'Created Date',
            selector: (row) => moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a'),
            cell: (row) => (
                <Tooltip title={moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a')} disableInteractive placement='top'>
                    <div className='text-truncate text-center'>{moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a')}</div>
                </Tooltip>
            ),
            width: "180px",
            center: true
        },
        {
            id: 'updatedAt',
            name: 'Updated Date',
            selector: (row) => moment(row?.updatedAt).format('DD/MM/YYYY, hh:mm a'),
            cell: (row) => (
                <Tooltip title={moment(row?.updatedAt).format('DD/MM/YYYY, hh:mm a')} disableInteractive placement='top'>
                    <div className='text-truncate text-center'>{moment(row?.updatedAt).format('DD/MM/YYYY, hh:mm a')}</div>
                </Tooltip>
            ),

            minWidth: '150px',
            center: true
        },
        {
            id: "action",
            name: "Action",
            cell: (row) => (
                <div className="d-flex justify-content-center">
                    <div className="d-flex align-items-center">
                        <div className="d-flex flex-row gap-3" role="button">
                            <Tooltip title="Edit" disableInteractive placement="top">
                                {checkUserPermissions("edit_banners") &&
                                    <div className="edit_icon_bg" onClick={() => handleEditClick(row)}>
                                        <img
                                            src={editIcon}
                                            alt="Edit"
                                            className="edit_icon"
                                        />
                                    </div>
                                }
                            </Tooltip>
                            <Tooltip title="Delete" disableInteractive placement="top">
                                <div className="delete_icon_bg" onClick={() => handleConfirm(row?.id)}>
                                    <img
                                        src={deleteIcon}
                                        alt="Delete"
                                        className="delete_icon"
                                    />
                                </div>
                            </Tooltip>
                        </div>
                    </div>
                </div>
            ),
            minWidth: "100px",
            center: true
        },
    ]

    const validationSchema = yup.object().shape({
        title: yup
            .string('Enter your firstName')
            .trim()
            .required('Title is required'),
        webImage: selectedBanner?.id ? yup.string().nullable() : yup.string().required('Image is required'),
        mobileImage: selectedBanner?.id ? yup.string().nullable() : yup.string().required('Image is required'),
    });

    const formik = useFormik({
        initialValues: {
            title: '',
            webImage: '',
            webImage_view: '',
            mobileImage: '',
            mobileImage_view: '',
            productId: '',
            selectedProduct: '',
            // subtitle: '',
            // subtitleImage: '',
            // subtitleImage_view: ''
        },
        validationSchema: validationSchema,
        validate: async (values) => {
            const errors = {}

            // if (values.webImage || values.mobileImage) {
            //     if (!values.webImage) {
            //         errors.webImage = "Web Image is required";
            //     }

            //     if (!values.mobileImage) {
            //         errors.mobileImage = "Mobile Image is required";
            //     }
            // }

            if (!values.selectedProduct) {
                errors.selectedProduct = "Product is required";
            }


            return errors
        },
        onSubmit: async (values, { resetForm }) => {
            setLoading(true);
            if (values.webImage == '') {
                delete values.webImage;
            }
            delete values.webImage_view;
            if (values.mobileImage == '') {
                delete values.mobileImage;
            }
            delete values.mobileImage_view;
            // if (values.subtitleImage == '') {
            //     delete values.subtitleImage;
            // }
            // delete values.subtitleImage_view;
            if (selectedBanner?.id) {
                editBanner(values)((response) => {
                    if (response && response?.data?.statusCode == 200) {
                        resetForm();
                        toast.success("Banner Updated Successfully")
                        handleClose();
                        setUpdate(!update);
                        setSelectedBanner(null);
                        setLoading(false);
                    } else {
                        setLoading(false);
                        toast.error(response?.data?.message);
                    }
                })
            } else {
                createBanner(values)((response) => {
                    if (response && response?.data?.statusCode == 200) {
                        resetForm();
                        toast.success("Banner Created Successfully")
                        handleClose();
                        setUpdate(!update);
                        setLoading(false);
                        setSelectedBanner(null);
                    } else {
                        setLoading(false);
                        toast.error(response?.data?.message);
                    }
                })
            }

        },
    });

    const handleShow = () => setShow(true);

    const handleClose = () => {
        formik.resetForm();
        setShow(false);
        setSelectedBanner(null)
    };

    const fetchBannerData = async () => {
        getBannerListing({ page: page, pageSize: limit, search })((response) => {
            if (response?.statusCode === 200) {
                setBanner(response?.data);
                setTotalRows(response?.data?.totalItems);
                setLoading(false);
            } else {
                setBanner([]);
                setLoading(false);
            }
        });
    };

    let typingTimer;
    const loadOptionsProducts = inputValue => {
        return new Promise((resolve, reject) => {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(() => {
                if (inputValue.length >= 3) {
                    getInventoryListingPaginate({ page: 1, limit: 10, search: inputValue })(response => {
                        console.log(response)
                        if (response?.statusCode == 200) {
                            console.log(response?.results)
                            resolve(response?.results);
                            setProducts(response?.results)
                        } else {
                        }
                    })
                }
                else {
                    resolve([]);
                }

            }, 300);
        });
    };

    const onProductChange = (selectedOption) => {
        console.log(selectedOption, 'selectedOption');
        formik.setValues({
            ...formik.values,
            productId: selectedOption ? selectedOption.value : '',
            selectedProduct: selectedOption,
        });
    };

    const handleEditClick = (banner) => {
        setSelectedBanner(banner);
        formik.setValues({
            ...formik.values,
            bannerId: banner?.id ?? '',
            productId: banner?.productId ?? '',
            selectedProduct: {
                value: banner?.Product?.id ? banner?.Product?.id : '',
                label: banner?.Product?.productName ? banner?.Product?.productName : ''
            },
            title: banner?.title ?? '',
            webImage_view: banner?.webImage ?? '',
            mobileImage_view: banner?.mobileImage ?? '',
            // subtitleImage_view: banner?.img ?? '',
        });
        setShow(true);
    };


    const handlePerRowsChange = (newPerPage, page) => {
        setLimit(newPerPage);
        setPage(1);
        setUpdate(!update);
    };

    const handlePageChange = (page) => {
        setPage(page);
        setUpdate(!update);
    };

    const toggleModal = () => {
        setModal(!modal);
    };

    const handleConfirm = (deletingId) => {
        setModal(!modal);
        setDeletingId(deletingId);
    };

    const handleWebImageChange = async (e) => {
        const file = e?.target?.files[0];
        const maxSizeInBytes = 2 * 1024 * 1024;
        const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

        if (file?.size > maxSizeInBytes) {
            toast.error("File size exceeds 2 MB limit", 'error')
            e.target.value = null;
            return;
        }

        if (!validImageTypes.includes(file?.type)) {
            toast.error("Only jpg/jpeg and png files are allowed!");
            e.target.value = null;
            return;
        }

        const response = await imageToBase64(URL.createObjectURL(file));
        formik.setValues({
            ...formik.values,
            webImage: response,
            webImage_view: 'data:image/jpeg;base64,' + response,
        });
    }

    const handleMobImageChange = async (e) => {
        const file = e?.target?.files[0];
        const maxSizeInBytes = 2 * 1024 * 1024;
        const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

        if (file?.size > maxSizeInBytes) {
            toast.error("File size exceeds 2 MB limit", 'error')
            e.target.value = null;
            return;
        }

        if (!validImageTypes.includes(file?.type)) {
            toast.error("Only jpg/jpeg and png files are allowed!");
            e.target.value = null;
            return;
        }

        const response = await imageToBase64(URL.createObjectURL(file));
        formik.setValues({
            ...formik.values,
            mobileImage: response,
            mobileImage_view: 'data:image/jpeg;base64,' + response,
        });
    }

    const handleSubImageChange = async (e) => {
        const file = e?.target?.files[0];
        const maxSizeInBytes = 2 * 1024 * 1024;
        const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

        if (file?.size > maxSizeInBytes) {
            toast.error("File size exceeds 2 MB limit", 'error')
            e.target.value = null;
            return;
        }

        if (!validImageTypes.includes(file?.type)) {
            toast.error("Only jpg/jpeg and png files are allowed!");
            e.target.value = null;
            return;
        }

        const response = await imageToBase64(URL.createObjectURL(file));
        formik.setValues({
            ...formik.values,
            subtitleImage: response,
            subtitleImage_view: 'data:image/jpeg;base64,' + response,
        });
    }

    const deleteBanner = (id) => {
        setLoading(true);
        deleteBannerItem(id)((response) => {
            if (response?.request?.status == 200) {
                setUpdate(!update);
                setModal(!modal);
                setLoading(false);
                toast.success("Banner deleted successfully")
            } else {
            }
        });
        // });
    };


    useEffect(() => {
        setLoading(true);
        fetchBannerData();
    }, [update]);


    useEffect(() => {
        let timeout = setTimeout(() => {
            if (initial) setUpdate(!update);
            else setInitial(!initial);
        }, 500);

        return () => {
            clearTimeout(timeout);
        };
    }, [search]);


    return (
        <>
            <div>
                <div className="col-12">
                    <div className="d-flex justify-content-between align-items-stretch py-2">
                        <div className="d-flex align-items-center">
                         <h3 className="mb-0  fw-bolder">Banners</h3>
                        </div>

                        <div className="d-flex align-items-center">
                            <div className=" d-flex align-items-center">
                                <Button className="request_btn" onClick={handleShow}>
                                    <FaRegSquarePlus className="icon" />
                                    Add New Banner
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="d_grid_wrapper"></div>
                </div>

                <div className='col-12'>
                    <Box className="products-and-options" sx={{ mt: 1 }}>
                        <Paper square className='shadow-none border border-blue-grey-200'>
                            <div>
                                <DataTable
                                    columns={columns}
                                    data={banner}
                                    progressPending={loading}
                                    progressComponent={<div style={{ height: '60vh' }}><Loader /></div>}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    paginationPerPage={limit}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    currentPage={page}
                                    customStyles={queueDatatableCustomStyles}
                                />
                            </div>
                        </Paper>
                    </Box>
                </div>
                <CreateBanner
                    show={show}
                    handleClose={handleClose}
                    handleShow={handleShow}
                    loading={loading}
                    loadOptionsProducts={loadOptionsProducts}
                    products={products}
                    onProductChange={onProductChange}
                    customStyles={customStyless}
                    formik={formik}
                    selectedBanner={selectedBanner}
                    handleWebImageChange={handleWebImageChange}
                    handleMobImageChange={handleMobImageChange}
                    handleSubImageChange={handleSubImageChange}
                />
                <CustomisedModal
                    isOpen={modal}
                    customClass={"policy_modal"}
                    toggle={toggleModal}
                >
                    <h5>Are you sure you want to remove this item?</h5>
                    <div className="policy_Agree">
                        <Button
                            onClick={() => {
                                setModal(!modal);
                            }}
                            size="lg"
                            className="btn_cancel"
                        >
                            Cancel
                        </Button>
                        <Button
                            size="lg"
                            className="btn"
                            onClick={() => deleteBanner(deletingId)}
                            disabled={loading}
                        >
                            Delete
                        </Button>
                    </div>
                </CustomisedModal>
            </div>
            {/* Image Modal Display */}
            <Modal
                show={showimg}
                onHide={handleCloseImage}
                centered
                className='modal_create'
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <div className="promo_modal_img">
                    <img src={webimg} alt='' className="img-fluid" />
                </div>
            </Modal>

            {/* Image Modal Display */}
            <Modal
                show={showmobimg}
                onHide={handleCloseMobImage}
                centered
                className='modal_create'
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <div className="promo_modal_img">
                    <img src={mobimg} alt='' className="img-fluid" />
                </div>
            </Modal>
        </>
    )
}

export default Banner